export default `{ 'src': asset->url, alt, caption, asset, 'id': asset->_id }`;
